import React, { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';

/** Forces LIGHT: the question players and result cards have no dark variants. Prior theme restored on exit. */
export const CandidateLayout: React.FC = () => {
  // useLayoutEffect runs before paint so the page never flashes dark. A
  // MutationObserver re-asserts light if anything (persisted-theme hydration,
  // the OS color-scheme listener, a theme switch) tries to put `.dark` back on
  // <html> while a candidate surface is mounted.
  useLayoutEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains('dark');
    const prevColorScheme = root.style.colorScheme;
    const forceLight = () => {
      if (root.classList.contains('dark')) root.classList.remove('dark');
      if (root.style.colorScheme !== 'light') root.style.colorScheme = 'light';
    };
    forceLight();
    const observer = new MutationObserver(forceLight);
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    return () => {
      observer.disconnect();
      if (hadDark) root.classList.add('dark');
      root.style.colorScheme = prevColorScheme;
    };
  }, []);

  return (
    <div data-surface="exam" className="min-h-dvh bg-background text-foreground">
      <Outlet />
    </div>
  );
};

export default CandidateLayout;
